<script>
export default {
  data() {
    return {
      selectedOption: this.formatProductgroupId ?? null,
    }
  },
  props: {
    mediaId: Number,
    productgroups: Array,
    formatProductgroupId: Number,
  },
  mounted() {
    this.getProductgroups();
  },
  methods: {
    assignMediaToProductgroup() {
      axios.put(Scoop.baseUrl + '/mediaserver/media/' + this.mediaId + '/manager/Media2ProductgroupManager',
          this.selected
      ).then((response) => {
        //this.selectedOption = response.data.format_productgroup_id;
      });
    },

    search(search, loading) {
      loading(true);
      this.getProductgroups(search, loading);
    },
    getProductgroups(search, loading) {
      let url = Scoop.baseUrl + '/mediaserver/media/' + this.mediaId + '/manager/Media2ProductgroupManager?method=search';

      if (search) {
        url += '&search=' + search;
      }

      axios.get(url).then(response => {
        this.products = response.data;

        if (loading !== undefined) {
          loading(false);
        }
      });
    },
  },
  computed: {
    selected() {
      return this.options.find(element => element.value === this.selectedOption);
    },
    options() {
      return _.map(this.productgroups, function (productgroup) {
        return {label: productgroup.productgroup_name, value: productgroup.id};
      });
    },
  },
  watch: {
    selectedOption(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.assignMediaToProductgroup();
      }
    }
  },
}
</script>

<template>
  <div>
    <h5 v-text="__('productgroups.assigned_format_productgroups')"></h5>
    <v-select @search="search" :options="options" :reduce="label => label.value"
              v-model="selectedOption" class="m-b"></v-select>
  </div>
</template>
